import messages from './common.json' with { type: 'json' };

export const commonEn: Readonly<typeof messages> = messages;
